// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"c32c54ed","453":"6c7a1784","483":"373609b5"}[chunkId] + ".chunk.js";
};